import { defineMessages } from '../define';

/** Annotation sync engine: default layer name and sync status texts (used by the annotate UI). */
export const sync = defineMessages(
  {
    'sync.title': 'Samstilling',
    'sync.default_layer': 'Mitt lag',
    'sync.copy_suffix': '{name} (afrit)',
    'sync.status.idle': 'Vistað',
    'sync.status.syncing': 'Vista…',
    'sync.status.offline': 'Ekkert net – vistað á tækinu',
    'sync.status.error': 'Ekki vistað',
    'sync.pending': { one: '{count} breyting bíður', other: '{count} breytingar bíða' },
    'sync.failed_hint': 'Sumar breytingar vistuðust ekki á þjóninum. Reyndu aftur síðar.',
    'sync.retry': 'Reyna aftur',
    'sync.last_sync': 'Síðast vistað {time}',
    'sync.stale_layers': 'Sumt var teiknað á eldri útgáfu nótnanna.',
  },
  {
    'sync.title': 'Sync',
    'sync.default_layer': 'My layer',
    'sync.copy_suffix': '{name} (copy)',
    'sync.status.idle': 'Saved',
    'sync.status.syncing': 'Saving…',
    'sync.status.offline': 'Offline – saved on this device',
    'sync.status.error': 'Not saved',
    'sync.pending': { one: '{count} change waiting', other: '{count} changes waiting' },
    'sync.failed_hint': 'Some changes were not saved on the server. Try again later.',
    'sync.retry': 'Try again',
    'sync.last_sync': 'Last saved {time}',
    'sync.stale_layers': 'Some markings were drawn on an older version of the sheet.',
  },
);
